import { render, staticRenderFns } from "./RecruiterDetailsPage.vue?vue&type=template&id=3d32c06e&"
import script from "./RecruiterDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./RecruiterDetailsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d32c06e')) {
      api.createRecord('3d32c06e', component.options)
    } else {
      api.reload('3d32c06e', component.options)
    }
    module.hot.accept("./RecruiterDetailsPage.vue?vue&type=template&id=3d32c06e&", function () {
      api.rerender('3d32c06e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Recruiter/RecruiterDetailsPage.vue"
export default component.exports